export default {
	// disabled
	'btn-disabled': '$white',
	'btn-disabled-bg': '$custom41',
	'btn-disabled-shadow': '$custom41',

	// primary
	'btn-primary': '$white',
	'btn-primary-bg': '$primary06',
	'btn-primary-shadow': '$primary04',
	'btn-primary-hover-shadow': '$primary06',
	'btn-primary-gradient': '$white',
	'btn-primary-gradient-bg':
		'linear-gradient(94.77deg, #009E6A 0.56%, #00C684 100%)',

	'btn-primary-active': 'inherit',
	'btn-primary-active-bg': 'none',
	'btn-primary-active-shadow': '$primary06',
	'btn-primary-focus-shadow': '$primary06',

	// secondary
	'btn-secondary': '$white',
	'btn-secondary-bg': '$grey06',
	'btn-secondary-shadow': '$grey07',
	'btn-secondary-hover-shadow': '$grey09',

	'btn-secondary-active': '$grey09',
	'btn-secondary-active-bg': '$grey02',
	'btn-secondary-active-shadow': '$grey07',

	'btn-secondary-focus-shadow': '$grey09',

	// danger
	'btn-danger': '$white',
	'btn-danger-bg': '$red06',
	'btn-danger-shadow': '$red07',
	'btn-danger-hover-shadow': '$red09',

	'btn-danger-active': '$red09',
	'btn-danger-active-bg': '$red02',
	'btn-danger-active-shadow': '$red07',

	'btn-danger-focus-shadow': '$red09',

	// outlined
	'btn-outlined': '$black',
	'btn-outlined-primary': '$primary09',
	'btn-outlined-secondary': '$grey09',
	'btn-outlined-danger': '$red07',
	'btn-outlined-bg': 'transparent',
	'btn-outlined-shadow': '$black',
	'btn-outlined-hover-shadow': '$black',

	'btn-outlined-active': '$black',
	'btn-outlined-active-bg': '$transparent',
	'btn-outlined-active-shadow': '$grey09',

	'btn-outlined-focus-shadow': '$grey09',

	'icon-btn': '$grey12',
	'icon-btn-bg': '$white',
	'icon-btn-border': '$grey4',
	'icon-btn-hover-border': '$grey6',

	'icon-btn-active-bg': '$grey3',
	'icon-btn-focus-border': '$grey7',
	'icon-btn-focus-shadow': '$grey7',
	'icon-btn-disabled': '$grey5',

	'icon-btn-ghost-hover-bg': 'hsl(210 98.8% 14.4% / 0.055)',
	'icon-btn-ghost-focus-shadow': 'hsl(205 96.5% 10.0% / 0.244)',
	'icon-btn-ghost-active-bg': 'hsl(210 94.1% 11.1% / 0.075)',

	'icon-btn-raised-focus-border': '$grey7',
	'icon-btn-raised-focus-shadow': '$grey7',
	'icon-btn-raised-active-bg': '$grey3',

	'icon-btn-waiting-bg': '$grey3',
}
